import React from 'react';
import Type from 'prop-types';
import { ListItem, ListItemText, ListItemSecondaryAction } from "@mui/material";
import { FormattedNumber } from 'components';
import styles from './PledgeItem.module.css';

const PledgeItem = (props) => {
  const {
    pledge: { rin, type, amount, depositCost },
  } = props;

  return (
    <ListItem ContainerComponent="div" button>
      <ListItemText
        primary={`RIN: ${rin}`}
        secondary={type.length > 0 ? type : null}
        secondaryTypographyProps={{
          classes: {
            root: styles.comment,
          },
        }}
      />

      <ListItemSecondaryAction>
        <div className={styles.actionContainer}>
          <FormattedNumber
            classes={{ root: styles.depositCost }}
            value={depositCost}
            options={{
              currency: 'RUB',
              style: 'currency',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }}
            color="textPrimary"
            variant="body1"
            component="span"
          />

          <FormattedNumber
            value={amount}
            options={{
              currency: 'RUB',
              style: 'currency',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }}
            color="textSecondary"
            variant="body1"
            component="span"
          />
        </div>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

PledgeItem.propTypes = {
  pledge: Type.shape({
    id: Type.string.isRequired,
    rin: Type.string.isRequired,
    type: Type.string,
    amount: Type.number,
    depositCost: Type.number,
  }).isRequired,
};

export default PledgeItem;
